import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import {
    deviceRegister, recordActivity
} from '../slices/register'

const Landing = (props) => {
    const dispatch = useDispatch();
    const [screen, setScreen] = useState(1)
    const {error, loading} = useSelector(state => ({
        ...state
    }));


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {},
        onSubmit: (values) => {
        }
    });

    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(recordActivity(deviceId, {
            action: "survey",
            page_id: "0-4"
        }))
    }, [dispatch, sessionStorage, recordActivity])

    document.title = "Study Information";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5  justify-content-center">
                        <Col className="p-0" xl={9} md={12} sm={12}>
                            <div className="text-center mt-2">
                                <h3>Telehealth for Problems with Opioid Use</h3>
                            </div>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">
                                            <Row className="justify-content-center">
                                                <Col className="pr-5 pl-5" xl={10} md={10} sm={12}>
                                                    <p>Thank you for your interest in the study. You will next be asked a series of questions to determine if you are eligible for participation in this study. It will take you about 5-10 minutes to complete all the questions. You must complete the survey to proceed to the next step. If you do not complete it and then try to resume later, you will start from the beginning.
                                                    </p>
                                                </Col>
                                                <Col className="pr-5 pl-5" xl={5} md={5} sm={12}>
                                                    <div className="mt-4 justify-content-center">
                                                        <Button aria-label={"begin enrollment survey"}
                                                                disabled={error ? null : loading ? true : false}
                                                                className="btn button-primary w-100" type="button"
                                                                style={{fontSize: 'x-large'}}
                                                                onClick={() => props.router.navigate('/online-enrollment')}>
                                                            Begin Enrollment Survey
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col className="pr-5 pl-5" xl={10} md={10} sm={12}>
                                                    <div className="mt-4">
                                                        <span> If you have questions about the study, you can request to be contacted by a research assistant (allow 2 business days).</span>
                                                    </div>
                                                </Col>
                                                <Col className="pr-5 pl-5" xl={5} md={5} sm={12}>
                                                    <div className="mt-4 justify-content-center">
                                                        <Button aria-label={"contact research assistant"}
                                                                disabled={error ? null : loading ? true : false}
                                                                className="btn button-primary w-100" type="button"
                                                                style={{fontSize: 'small'}}
                                                                onClick={() => props.router.navigate('/guided-enrollment')}>
                                                            Contact Research Assistant
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <br/>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(Landing);
